import { Pressable, StyleSheet, Text, type StyleProp, type ViewStyle } from 'react-native';

import { colors, radius, type } from '@/theme';

type ButtonProps = {
  label: string;
  onPress: () => void;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
};

export function PrimaryButton({ label, onPress, disabled, style }: ButtonProps) {
  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      style={({ pressed }) => [
        styles.primary,
        pressed && styles.pressed,
        disabled && styles.disabled,
        style,
      ]}>
      <Text style={styles.primaryLabel}>{label}</Text>
    </Pressable>
  );
}

export function GhostButton({ label, onPress, disabled, style }: ButtonProps) {
  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      style={({ pressed }) => [styles.ghost, pressed && styles.pressed, style]}>
      <Text style={[styles.ghostLabel, disabled && styles.ghostLabelDim]}>{label}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  primary: {
    backgroundColor: colors.text,
    borderRadius: radius.pill,
    paddingVertical: 18,
    alignItems: 'center',
  },
  primaryLabel: {
    ...type.label,
    fontSize: 13,
    color: colors.bg,
  },
  ghost: {
    borderRadius: radius.pill,
    paddingVertical: 16,
    alignItems: 'center',
  },
  ghostLabel: {
    ...type.body,
    fontSize: 15,
    color: colors.dim,
  },
  ghostLabelDim: {
    color: colors.faint,
  },
  pressed: {
    opacity: 0.65,
    transform: [{ scale: 0.985 }],
  },
  disabled: {
    opacity: 0.4,
  },
});
